import React from 'react';
import { IconButton, Tooltip } from 'pounceV2';
import { SxProps, Theme } from '@mui/system';
import { useTheme } from '@mui/material';

const AIStopButtonV3 = ({
  cancelPrompt,
  sx,
}: {
  cancelPrompt: () => void;
  sx?: SxProps<Theme>;
}) => {
  const {
    palette: { componentTokens },
  } = useTheme();
  const stopColor = componentTokens.buttons.colors.link.destructive.text.hover;

  return (
    <Tooltip content="Stop response">
      <IconButton
        aria-label="Stop"
        icon="stop-circle"
        size="medium"
        type="button"
        variant="ghost"
        flexShrink={0}
        sx={{
          '&:hover': {
            color: stopColor,
          },
          ...(sx || {}),
        }}
        onClick={e => {
          e.preventDefault();
          cancelPrompt();
        }}
      />
    </Tooltip>
  );
};

export default AIStopButtonV3;
